module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assinantes/assinantes.component.css
// module id = ./src/app/assinantes/assinantes.component.css
// module chunks = main